import React from 'react';
import {Card, ListGroup, Dropdown} from 'react-bootstrap';
import '../CheckinView.css';
import CheckinGraph from './CheckinGraph';
import moment from 'moment-timezone';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {MDBCheckbox} from 'mdb-react-ui-kit';

/**
 * La vue du checkin
 * @param {*} props props
 * @return {JSX}
 */
function CheckinView(props) {
  const formatDate = (dateString) => {
    const date = moment.tz(dateString, 'America/Montreal');
    const dayNames = {
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
    };
    moment.locale('fr'); // set locale to French
    const dayName = dayNames[date.format('dddd')];
    return `${dayName} le ${date.format('DD-MM-YYYY')}`;
  };

  return (
    <div className="checkin-container">
      <Card className="checkin-card">
        <Card.Header className="checkin-header">{formatDate(props.startend.date)}
          {props.week <= 1 ? <button className="checkin-pagination-button float-end" onClick={() => props.handleUpdate(props.startend.id, props.startend)}><FontAwesomeIcon icon={faPencilAlt} /></button> : ''}
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroup.Item className="checkin-list-item">Chantier: {props.startend.place}</ListGroup.Item>
          <ListGroup.Item className="checkin-list-item"
            style={{backgroundColor: props.startend.from === null || props.startend.to === null ? 'red' : 'white'}}>
            Heure: {props.startend.from === null ? '-' : props.startend.from} à {props.startend.to === null ? '-' : props.startend.to}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">Transport: {props.startend.transport === 1 ? 'Oui' : 'Non'}</ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">Travaillé avec:
            {props.startend.work_with.length === 0 ? (
                      ' Aucun employé'
                    ) : (
                      <Dropdown>
                        <Dropdown.Toggle
                          className="chantierheure-dropdown"
                          style={{
                            all: 'unset',
                            backgroundColor: 'white',
                            color: 'black',
                            cursor: 'pointer',
                          }}>
                          {props.startend.work_with[0].label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {props.startend.work_with.map((w, index) => {
                            return <Dropdown.Item key={index}>{w.label}</Dropdown.Item>;
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
          </ListGroup.Item>
          <ListGroup.Item>
            <MDBCheckbox name='inlineCheck' id='inlineCheckbox111' checked={props.startend.extra1} label='Extra possible' disabled inline />
            {localStorage.getItem('admin') === '1' ?
            <React.Fragment>
              <MDBCheckbox name='inlineCheck' id='inlineCheckbox222' checked={props.startend.extra2} label='Extra valider' disabled inline />
              <MDBCheckbox name='inlineCheck' id='inlineCheckbox333' checked={props.startend.extra3} label='Extra confirmer' disabled inline />
            </React.Fragment> : ' ' }

          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">Note: {props.startend.note}</ListGroup.Item>
        </ListGroup>
        {props.checkedGraph ? <Card.Body> {props.startend.taches.length !== 0 ? <CheckinGraph taches={props.startend.taches}/> : ''}</Card.Body> : ''}
      </Card>
    </div>
  );
}

export default CheckinView;
